import React from "react";
import { Box, Typography } from "@mui/material";
import ExportSection from "../components/ExportSection";

const ExportPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Exportar Dados
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Exporte as suas faturas para diferentes formatos.
        </Typography>
      </Box>
      <ExportSection />
    </Box>
  );
};

export default ExportPage;
